import { types } from 'mobx-state-tree'
import { DecimalType } from './ModelTypes'  

export const WithLatLngModel = 
    types.model('WithLatLngModel')
    .props({
        latitude_deg: DecimalType,
        longitude_deg: DecimalType,
    })
    .views((self) => ({
        get latitudeDeg(): number {
            return parseFloat(self.latitude_deg)
        },
        get longitudeDeg(): number {
            return parseFloat(self.longitude_deg)
        },  
        get toGmapLatLng(): google.maps.LatLngLiteral {
            return { lat: parseFloat(self.latitude_deg), lng: parseFloat(self.longitude_deg)}
        }    
    }))
    
export const WithEditableLatLngModel = 
    types.model('WithLatLngModel')
    .props({
        latitude_deg: types.maybeNull(DecimalType),
        longitude_deg: types.maybeNull(DecimalType),
    })
    .views((self) => ({
        get latitudeDeg(): typeof self.latitude_deg {
            return self.latitude_deg
        },
        get longitudeDeg(): typeof self.longitude_deg {
            return self.longitude_deg
        },  
        get toGmapLatLng(): google.maps.LatLngLiteral | null {
            if (self.latitude_deg === null || self.longitude_deg === null) {
                return null
            }
            const [lat, lng] = [parseFloat(self.latitude_deg), parseFloat(self.longitude_deg)]
            if (isNaN(lat) || isNaN(lng)) {
                return null
            }
            return { lat, lng }
        }    
    }))
    .views((self) => ({
        // Test whether the coordinate is a well-formed number.
        // Unfortunately, in JS using only `parseFloat` isn't enough, since it allows "3.14stuff" and using only `Number()` isn't enough since it allows spaces.
        // See https://stackoverflow.com/questions/175739/how-can-i-check-if-a-string-is-a-valid-number
        get isLatitudeValid(): boolean {
            return self.latitude_deg !== null && !isNaN(Number(self.latitude_deg)) && !isNaN(parseFloat(self.latitude_deg))
        },
        get isLongitudeValid(): boolean {
            return self.longitude_deg !== null &&  !isNaN(Number(self.longitude_deg)) && !isNaN(parseFloat(self.longitude_deg))
        },
    }))
    .actions((self) => ({
        setLatitude(latitudeDeg: typeof self.latitudeDeg): void {
            self.latitude_deg = latitudeDeg
        },
        setLongitude(longitudeDeg: typeof self.longitudeDeg): void {
            self.longitude_deg = longitudeDeg
        },
        
    }))
    .actions((self) => ({
        setPosition(lat: number, lon: number): void {
            self.setLatitude(lat.toString())
            self.setLongitude(lon.toString())
        },
    }))